export default class ProductIdent {
  [key: string]: string | number;
  systemIdent: string = "";
  name: string = "";
  manufacturerIdent: string = "";
  id: string = "";
  quantities: string = "";
}
